import { useTranslation } from 'react-i18next';

import { InputAdornment } from '@frontierag/frontier-ui-library';
import { PRODUCT_PRICE_CURRENCY } from 'appConstants';
import { TextField } from 'fields';

import type { IProductPrice } from './types';

export default function ProductPrice({ disabled }: IProductPrice) {
  const { t } = useTranslation('CreateOrder');

  return (
    <TextField
      required
      type="number"
      disabled={disabled}
      name="packagedItemPrice"
      label={t('ProductForm.labels.price')}
      placeholder={t('ProductForm.placeholders.price')}
      InputProps={{
        startAdornment: <InputAdornment position="start">{PRODUCT_PRICE_CURRENCY}</InputAdornment>,
      }}
      skipArithmeticSign
    />
  );
}
